// @ts-check
import useScimSetting from 'common/hooks/settings/useScimSetting';
import { Switch } from '@material-ui/core';
import { useState } from 'react';
import { configureScimWithOktaDocs } from 'common/constants/articles';
import { StyledLink } from 'components/base/common-styles';
import { StyledScimSetting } from './ScimSetting.style';
import { LBButton } from '@linearb/buzz';

const ScimSetting = () => {
  const scimSetting = useScimSetting();
  const [isEnabled, setIsEnabled] = useState(scimSetting.isEnabled);

  return (
    <StyledScimSetting>
      <Switch onClick={() => setIsEnabled(prev => !prev)} checked={isEnabled} />
      <main>
        <header>Activate SCIM Provisioning</header>
        <section>
          When enabled, you can onboard and manage LinearB users using your
          identity provider. Learn more about{' '}
          <StyledLink href={configureScimWithOktaDocs} target='_blank'>
            SCIM Provisioning
          </StyledLink>
        </section>
      </main>
      <div className='ml-auto'>
        <LBButton
          disabled={scimSetting.isEnabled === isEnabled}
          onClick={scimSetting.toggleActivision}
        >
          Save
        </LBButton>
      </div>
    </StyledScimSetting>
  );
};

export default ScimSetting;
